
































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils";
const addQuestionRules = () => import("./component/addQuestionRules.vue");

@Component({
  name: "CombinationProperty",
  components: {
    addQuestionRules,
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private activeName: string = "third";
  @Provide() private questionList: any;
  @Provide() private resultData: any = []; //列表
  @Provide() private result: any = {
    id: "",
    qptype: "",
    questionsnum: "", //问题数量
    displaynum: "", //展示数量
    itemid: "", //工单类型
    questions: "", //问题IDs
    status: "",
    opuid: "",
    utime: "",
    floatinfo: "",
    opname: "", //操作人
    loantype: "", //贷款类型
    idverify: "", //实名审核
  };
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private name: any = ""; //用户账户
  @Provide() private title: any = "添加";
  @Provide() private QpType: any = ""; //问题类型
  @Provide() private questionOptions: any = [
    { id: 1, name: "0类问题" },
    { id: 2, name: "1类问题" },
    { id: 3, name: "2类问题" },
  ];
  @Provide() private isAddQuestion: boolean = false; // lee 是否展示添加弹窗
  @Provide() private applist: any = "";
  @Provide() private appname: any = ""; 
  private created() {
    this.token = localStorage.getItem("token");
    this.searchFormAction();
  }
  private selectList() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.searchFormAction();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.searchFormAction();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.searchFormAction();
    }
  }
  // 隐藏添加弹窗
  private returnRiskReport() {
    this.isAddQuestion = false;
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.searchFormAction();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.searchFormAction();
  }

  private hideDialog(): void {
    this.isAddQuestion = false;
  }
  // lee 关闭所有弹窗
  private hideAllDialog() {
    this.isAddQuestion = false;
    this.searchFormAction();
  }
  private updateList() {
    this.pageIndex = 1;
    this.QpType = "";
    this.name = "";
    this.searchFormAction();
  }

  private formatLoanType(source: any) {
    if (source != null && source != undefined) {
      if (source == "0") {
        return "默认";
      } else if (source == "1") {
        return  this.$tc("dashbordDy.firstLoan");//"首贷";
      } else if (source == "2") {
        return this.$tc("dashbordDy.CompoundLoan");//"复贷";
      } else if (source == "3") {
        return this.$tc('v0707.FirstsubsequentLoan');//"首复贷";
      }
      return "";
    } else {
      return "";
    }
  }

  private formatIDVerify(source: any) {
    if (source != null && source != undefined) {
      if (source == "0") {
        return "全部";
      } else if (source == "1") {
        return "实名审核";
        // return  this.$tc("dashbordDy.firstLoan");//"实名审核";
      } else if (source == "2") {
        return "非实名审核";
        // return this.$tc("dashbordDy.CompoundLoan");//"非实名审核";
      }
      return "";
    } else {
      return "";
    }
  }

  // 列表
  private async searchFormAction() {
    this.isSearchFormActionDone = true;
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      QpType: this.QpType,
      Value: this.name,
      appname: this.appname?.toString()
    };
    const { getListQuestionDisplayReq, getListQuestionDisplayRequest }: any =
      await import("@/request/questionConfiguration");
    let res = await getListQuestionDisplayRequest.handleHttp(
      getListQuestionDisplayReq(_arg),
      this
    );
    this.applist = res.applist
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res && res.right) {
      this.pagerCount = res.pageout.total;
      this.resultData =
        res.listList && res.listList.length > 0 ? res.listList : [];
      this.resultData.forEach((item: any) => {
        let qptypemes = "";
        switch (item.qptype) {
          case 1:
            qptypemes = "0类问题";
            break;
          case 2:
            qptypemes = "1类问题";
            break;
          case 3:
            qptypemes = "2类问题";
            break;
        }
        let statusname = "";
        // 1 有效 2 失效 3已关联 0 失效
        switch (item.status) {
          case 0:
            statusname = "有效";
            break;
          case 1:
            statusname = "失效";
            break;
          case 2:
            statusname = "有效";
            break;
          case 3:
            statusname = "已关联";
            break;
        }
        let itemidname = "";
        switch (item.itemid) {
          case 100:
            itemidname = "PV";
            break;
          case 201:
            itemidname = "全部";
            break;
          case 101:
            itemidname = "IR";
            break;
          case 107:
            itemidname = "CPV";
            break;
        }
        let displayname = "";
        switch (item.display) {
          case 2:
            displayname = "随机展示";
            break;
          case 3:
            displayname = "固定展示";
            break;
          case 1:
            displayname = "全部展示";
            break;
        }
        let floatinfos: any = [];
        floatinfos = item.floatinfo?.split(";");
        this.$set(item, "floatinfos", floatinfos.join("<br/><br/>"));
        this.$set(item, "qptypemes", qptypemes);
        this.$set(item, "statusname", statusname);
        this.$set(item, "itemidname", itemidname);
        this.$set(item, "utimes", timeFormat(Number(item.utime)));
        this.$set(item, "displayname", displayname);
      });
    } else {
      this.isSearchFormActionDone = false;
    }
  }
  private addLoadAttr() {
    this.result = {
      id: "",
      qptype: "",
      questionsnum: "", //问题数量
      displaynum: "", //展示数量
      itemid: "", //工单类型
      questions: "", //问题IDs
      status: "",
      opuid: "",
      utime: "",
      floatinfo: "",
      opname: "", //操作人
      loantype: "", //贷款类型
      idverify: "", //实名审核
    };
    this.isAddQuestion = true;
    this.title = "添加";
  }
  private editLoadAttr(row: any) {
    this.result.id = row.id;
    this.result.appname = row.appname;
    this.result.qptype = row.qptype;
    this.result.questionsnum = row.questionsnum; //问题数量
    this.result.displaynum = row.displaynum; //展示数量
    this.result.display = row.display; //展示数量
    this.result.itemid = row.itemid; //工单类型
    this.result.questions = row.questions; //问题IDs
    this.result.status = row.status;
    this.result.opuid = row.opuid;
    this.result.utime = row.utime;
    this.result.floatinfo = row.floatinfo;
    this.result.opname = row.opname; //操作人
    this.result.loantype = row.loantype; //贷款类型
    this.result.idverify = row.idverify; //实名审核
    this.isAddQuestion = true;
    this.title = "编辑";
  }
  // 点击失效or有效
  private async changeStatus(row: any) {
    let status = "";
    switch (row.status) {
      case 0:
        status = "1";
        break;
      case 1:
        status = "2";
        break;
      case 2:
        status = "1";
        break;
      case 3:
        status = "1";
        break;
    }
    let _arg: any = {
      id: row.id,
      qptype: row.qptype,
      questionsnum: row.questionsnum, //问题数量
      displaynum: row.displaynum, //展示数量
      itemid: row.itemid, //工单类型
      questions: row.questions, //问题IDs
      status: +status,
      opuid: +row.opuid,
      utime: +row.utime,
      floatinfo: row.floatinfo,
      opname: row.opname, //操作人
      loantype: row.loantype, //贷款类型，
      idverify: row.idverify, //实名审核，
      display: row.display, //展示类型
      appname: row.appname
    };
    const { getSaveQuestionDisplayReq, getSaveQuestionDisplayRequest }: any =
      await import("@/request/questionConfiguration");
    let res = await getSaveQuestionDisplayRequest.handleHttp(
      getSaveQuestionDisplayReq(_arg),
      this
    );
    if (res && res.right) {
      this.searchFormAction();
      this.$message.success("状态修改成功!");
    }
  }
}
